import React from "react";
import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
  TwoColumnSectionBase,
  BadgeBase,
} from "@reusejs/react";

let firstSectionData = {
  title: "Search, Identify, Approach, Sit back, and Buy Online",
};

let secondSectionData = {
  description:
    "Auction Bazaar helps potential bidders to search for and bid on auction properties listed by banks, NBFCs, ARCs, and other financial institutions. Best-in-class market rates, user-centric interface, and end-to-end solutions make us a complete platform for bidding on auctions. Value for customer insights, trust, satisfaction, forging a good relationship is our foremost priority.",
};

export default function Mission() {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "bg-white overflow-hidden py-10 md:py-16",
        innerContainerStyles: "max-w-7xl mx-auto px-4 sm:px-6 xl:px-0",
      }}
    >
      <BadgeBase
        label={"Mission"}
        badgeBaseClasses={{
          borderRadius: "rounded-md",
          font: "text-xxs md:text-sm",
        }}
      />
      <div className="mt-3">
        <TwoColumnSectionBase
          firstColumnEl={
            <IconTitleDescriptionActionCard
              title={firstSectionData.title}
              itemTitleDescriptionCardBaseClasses={{
                titleWrapper: "text-left",
                titleStyles:
                  "text-xl md:text-3xl font-extrabold text-gray-900 sm:text-3xl sm:leading-none sm:tracking-tight lg:text-4xl",
              }}
            />
          }
          secondColumnEl={
            <IconTitleDescriptionActionCard
              description={secondSectionData.description}
              itemTitleDescriptionCardBaseClasses={{
                descriptionWrapper: "text-left mt-2",
                descriptionStyles:
                  "max-w-xl text-base md:text-xl text-gray-500 font-normal",
              }}
            />
          }
          twoColumnSectionBaseClasses={{
            firstElWrapperStyles: "w-full md:w-1/2 sm:pr-16",
            secondElWrapperStyles:
              "w-full md:w-1/2 mt-3.5 sm:mt-0 self-stretch md:pl-16",
            columnsFlexWrapperStyles:
              "flex justify-between flex-col md:flex-row",
          }}
        />
      </div>
    </SectionContainerBase>
  );
}
